const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkingPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg826",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path1058",
    d: "m2 19c0-1.5001 0.61298-2.9387 1.7041-3.9995 1.0911-1.0607 2.571-1.6566 4.1141-1.6566 1.5431 0 3.0229 0.5959 4.1141 1.6566 1.0911 1.0608 1.7041 2.4994 1.7041 3.9995zm5.8182-6.3631c-2.4109 0-4.3636-1.8984-4.3636-4.2421 0-2.3438 1.9527-4.2421 4.3636-4.2421 2.4109 0 4.3636 1.8983 4.3636 4.2421 0 2.3437-1.9527 4.2421-4.3636 4.2421zm6.7243-6.9401c0.3633 0.8556 0.5496 1.7724 0.5484 2.698 0.0012 0.9256-0.1851 1.8424-0.5484 2.698l-1.2196-0.8626c0.2081-0.59075 0.314-1.211 0.3135-1.8354 8e-4 -0.6244-0.1049-1.2446-0.3128-1.8354zm2.4015-1.6968c0.6969 1.3658 1.0583 2.8702 1.056 4.3948 0 1.5788-0.3804 3.0713-1.056 4.3948l-1.1964-0.8456c0.5275-1.1129 0.7997-2.3239 0.7978-3.5492 0-1.267-0.2858-2.4696-0.7978-3.5492z",
    fill: "#333",
    style: {
      fill: "#0067ce"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingPoints);
export default __webpack_public_path__ + "static/media/talking-points.388889fdd57e9c7c5758505269389eb0.svg";
export { ForwardRef as ReactComponent };